import { render, staticRenderFns } from "./recordFramework.vue?vue&type=template&id=1fb33450&scoped=true&"
import script from "./recordFramework.vue?vue&type=script&lang=js&"
export * from "./recordFramework.vue?vue&type=script&lang=js&"
import style0 from "./recordFramework.vue?vue&type=style&index=0&id=1fb33450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb33450",
  null
  
)

export default component.exports